import styles from './TableTitleArea.module.scss';
import { Heading } from '../../display/Heading';

type Props = {
  /**
   * The title of the table and any actions that apply to the entire
   * `Table`, such as a filtering mechanism. These children display
   * in a CSS Grid, so be sure to render them directly into `TableTitleArea`.
   */
  children: React.ReactNode;
  /**
   * The visual rendering of `TableTitleArea`. Matches up with `Table[kind]`.
   */
  kind?: 'standard' | 'custom';
};

export const TableTitle = (props: { children: React.ReactNode }) => {
  return <Heading className={styles.title}>{props.children}</Heading>;
};

/**
 * Displays the title and actions for a `Table`.
 */
export const TableTitleArea = ({ children, kind = 'standard' }: Props) => {
  return (
    <header className={styles.tableTitleArea} data-kind={kind} data-zds>
      {children}
    </header>
  );
};
